module.exports = __webpack_public_path__ + "files/7b1d415efa3f25d299cda1f18948cfbd.svg";